export default __webpack_public_path__ + "static/life-at-everly-572a47968c60ed755cc2e465104b7e23.webm";